import { gql } from '@/__generated__/gql';

export const GET_OPERATION_WORKFLOW_TRANSITION_TASK_SUMMARIES_QUERY = gql(`
  query FatTransactionsPageAllocationTransactionsTaskSummaries(
    $limit: Int
    $offset: Int
    $sort: String
    $order: String
    $search: String
    $tenantId: String
    $investmentId: String
    $operationWorkflowTransitionTaskIds: [String!]
  ) {
    allocationTransactions(
      limit: $limit
      offset: $offset
      sort: $sort
      order: $order
      search: $search
      tenantId: $tenantId
      investmentId: $investmentId
      operationWorkflowTransitionTaskIds: $operationWorkflowTransitionTaskIds
    ) {
      operationWorkflowTransitionTaskSummaries {
        id
        name
        count
        order
        totalCommittedCapital
      }
    }
  }
`);

export const ALLOCATION_TRANSACTIONS_QUERY = gql(`
  query FatTransactionsPageAllocationTransactions(
    $limit: Int
    $offset: Int
    $sort: String
    $order: String
    $search: String
    $tenantId: String
    $investmentId: String
    $operationWorkflowTransitionTaskIds: [String!]
  ) {
    allocationTransactions(
      limit: $limit
      offset: $offset
      sort: $sort
      order: $order
      search: $search
      tenantId: $tenantId
      investmentId: $investmentId
      operationWorkflowTransitionTaskIds: $operationWorkflowTransitionTaskIds
    ) {
      total
      limit
      offset
      allocations {
        id
        committedCapital
        lastUpdatedAt
        proposalType
        decision
        reason
        tenant {
          id
          name
        }
        legalEntity {
          id
          entityName
          family {
            id
            name
          }
        }
        investment {
          id
          name
          minimum
          investorDocsDue
        }
        assignee {
          id
          email
          firstName
          lastName
        }
        operationsWorkflowTransitionTask {
          id
          name
          transitionText
          lastUpdate
          transitionTemplate
          order
          createdAt
          availableActions
          action
          transitionTemplateObject {
            inputSchemaName
            logHistory
            nextTask
            requestMethod
            requestType
            responseSchemaName
          }
        }
        subscriptionDocument {
          id
          docusignEnvelopeId
          signatureType
          hasFundManagerSignatory
        }
      }
    }
  }
`);

export const UPDATE_ALLOCATION_AMOUNT_MUTATION = gql(`
  mutation FatTransactionsPageUpdateAllocationAmount($data: AllocationAmountUpdateDto!) {
    updateAllocationAmount(data: $data) {
      id
      committedCapital
      lastUpdatedAt
      proposalType
      allocationStatus
    }
  }
`);

export const INVESTMENTS_QUERY = gql(`
  query FatTransactionsPageRecommendationInvestmentsList {
    RecommendationInvestmentsList {
      id
      name
    }
  }
`);

export const ALLOCATION_QUERY = gql(`
  query FatTransactionsPageAllocation($id: String!) {
    Allocation(id: $id) {
      id
      committedCapital
      lastUpdatedAt
      proposalType
      decision
      reason
      allocationStatus
      assignee {
        id
        email
        firstName
        lastName
      }
      operationsWorkflowTransitionTask {
        id
        name
        transitionText
        lastUpdate
        transitionTemplate
        order
        createdAt
        availableActions
        action
        transitionTemplateObject {
          inputSchemaName
          logHistory
          nextTask
          requestMethod
          requestType
          responseSchemaName
        }
      }
      subscriptionDocument {
        id
        docusignEnvelopeId
        signatureType
        hasFundManagerSignatory
      }
    }
  }
`);

export const UPDATE_ALLOCATION_INVESTMENT_VEHICLE_MUTATION = gql(`
  mutation FatTransactionsPageUpdateAllocationInvestmentVehicle($data: AllocationInvestmentVehicleUpdateDto!) {
    updateAllocationInvestmentVehicle(data: $data) {
      id
    }
  }
`);

export const SUBSCRIPTION_DOCUMENT_FUND_MANAGER_URL_QUERY = gql(`
  query FatTransactionsPageSubscriptionDocumentFundManagerUrl($subscriptionDocumentId: ID!) {
    subscriptionDocumentFundManagerUrl(subscriptionDocumentId: $subscriptionDocumentId)
  }
`);

export const SEND_DEAL_DOCUMENTS_EMAIL_MUTATION = gql(`
  mutation FatTransactionsPageSendDealDocumentsEmail($data: SendDealDocumentsInput!) {
    sendDealDocumentsEmail(data: $data)
  }
`);

export const EXECUTE_ACTION_MUTATION = gql(`
  mutation FatTransactionsPageExecuteAction($data: AllocationOperationExecuteActionInput!) {
    executeAction(data: $data) {
      parsedInput
      parsedResponse
    }
  }
`);

export const REMAINING_RECIPIENTS_LIST_QUERY = gql(`
  query FatTransactionsPageRemainingRecipientsList($subscriptionDocumentId: ID!) {
    remainingRecipientsList(subscriptionDocumentId: $subscriptionDocumentId) {
      recipients {
        name
      }
      lastSentAt
    }
  }
`);
